import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import searchFill from '@iconify/icons-eva/search-fill';
import trash2Fill from '@iconify/icons-eva/trash-2-fill';
import roundRefresh from '@iconify/icons-ic/round-refresh';
import { useState, useEffect } from 'react';
import NoteAddIcon from '@material-ui/icons/NoteAdd';
// material
import { experimentalStyled as styled } from '@material-ui/core/styles';
import {
  Box,
  Toolbar,
  Tooltip,
  IconButton,
  Typography,
  OutlinedInput,
  InputAdornment,
  MenuItem,
  Button,
  TextField
} from '@material-ui/core';
import { baseUrl, tempProvinces, claimTypes, claimStatuses } from '../../../utils/constants';

const RootStyle = styled(Toolbar)(({ theme }) => ({
  height: 96,
  display: 'flex',
  justifyContent: 'space-between',
  padding: theme.spacing(0, 1, 0, 3)
}));

const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
  size: 'small',
  width: 240,
  transition: theme.transitions.create(['box-shadow', 'width'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter
  }),
  '&.Mui-focused': { width: 320, boxShadow: theme.customShadows.z8 },
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${theme.palette.grey[500_32]} !important`
  }
}));

ClaimsListToolbar.propTypes = {
  numSelected: PropTypes.number,
  filterName: PropTypes.string,
  onFilterName: PropTypes.func
};

export default function ClaimsListToolbar({
  numSelected,
  filterName,
  onFilterName,
  setFilterName,
  setFilterField
}) {
  const [provinces, setProvince] = useState(0);
  const handleRefresh = () => {
    setProvince(0);
    setServiceType(0);
    setClaimStatus(0);
    setFilterName('');
    setFilterField('memberShipNo');
    // Optionally call API to reload unfiltered data
    // fetchData();
  };

  const changeToProvince = (e) => {
    setProvince(e);
    const updatedTasks = tempProvinces.filter((t) => t.refId === e);
    console.log('updated task', updatedTasks[0]);
    console.log('updated task', updatedTasks[0].name);
    setFilterName(updatedTasks[0].name);
    setFilterField('province');
  };
  const [serviceType, setServiceType] = useState(0);

  const changeToServiceType = (e) => {
    setServiceType(e);
    const updatedTasks = claimTypes.filter((t) => t.refId === e);
    console.log('updated task', updatedTasks[0]);
    console.log('updated task', updatedTasks[0].name);
    setFilterName(updatedTasks[0].name);
    setFilterField('serviceType');
  };
  const [claimStatus, setClaimStatus] = useState(0);

  const ChangeToClaimStatus = (e) => {
    setClaimStatus(e);
    const updatedTasks = claimStatuses.filter((t) => t.refId === e);
    console.log('updated task', updatedTasks[0]);
    console.log('updated task', updatedTasks[0].name);
    setFilterName(updatedTasks[0].name);
    setFilterField('claimStatus');
  };

  return (
    <RootStyle
      sx={{
        ...(numSelected > 0 && {
          color: 'primary.main',
          bgcolor: 'primary.lighter'
        })
      }}
    >
      {numSelected > 0 ? (
        <Typography component="div" variant="subtitle1">
          {numSelected} selected
        </Typography>
      ) : (
        <SearchStyle
          value={filterName}
          onChange={onFilterName}
          placeholder="Search list..."
          startAdornment={
            <InputAdornment position="start">
              <Box component={Icon} icon={searchFill} sx={{ color: 'text.disabled' }} />
            </InputAdornment>
          }
        />
      )}

      {numSelected > 0 ? (
        <Tooltip title="Delete">
          <IconButton>
            <Icon icon={trash2Fill} />
          </IconButton>
        </Tooltip>
      ) : (
        <Button
          type="button"
          variant="outlined"
          color="secondary"
          // startIcon={<NoteAddIcon />}
          onClick={() => handleRefresh()}
        >
          Clear All
        </Button>
      )}
      <TextField
        id="standard-select-currency"
        style={{ width: 180, height: 30, pb: 2 }}
        select
        size="small"
        label="Province"
        value={provinces}
        onChange={(e) => changeToProvince(e.target.value)}
      >
        <MenuItem disabled value="0">
          <em>Select Province</em>
        </MenuItem>
        {tempProvinces.map((option) => (
          <MenuItem key={option.refId} value={option.refId}>
            {option.name}
          </MenuItem>
        ))}
      </TextField>
      <TextField
        id="standard-select-currency"
        style={{ width: 180, height: 30, pb: 2 }}
        select
        size="small"
        label="Service Type"
        value={serviceType}
        onChange={(e) => changeToServiceType(e.target.value)}
      >
        <MenuItem disabled value="">
          <em>Service Type</em>
        </MenuItem>
        {claimTypes.map((option) => (
          <MenuItem key={option.refId} value={option.refId}>
            {option.name}
          </MenuItem>
        ))}
      </TextField>
      <TextField
        id="standard-select-currency"
        style={{ width: 180, height: 30, pb: 2 }}
        select
        size="small"
        label="Claim Status"
        value={claimStatus}
        onChange={(e) => ChangeToClaimStatus(e.target.value)}
      >
        <MenuItem disabled value="">
          <em>Claim status</em>
        </MenuItem>
        {claimStatuses.map((option) => (
          <MenuItem key={option.refId} value={option.refId}>
            {option.name}
          </MenuItem>
        ))}
      </TextField>
    </RootStyle>
  );
}
